import * as React from 'react';

import {TemplateRCDataFromRequest} from 'core/RateConfirmation/types';
import {getTransformDataToTemplate} from 'core/RateConfirmation/modules/transformDataToTemplate';

import styles from './styles.module.scss';

type OwnProps = {
    data: TemplateRCDataFromRequest;
    isNATemplate: boolean;
};

const Requirements: React.FC<OwnProps> = ({data, isNATemplate = false}) => {
    const {fax, titleWithFax, titleWithoutFax, titleThanks, currentCarrier} = getTransformDataToTemplate(data);

    const createMarkup = () => {
        return {__html: titleWithFax};
    };

    return (
        <div className={styles.footer}>
            {isNATemplate ? (
                <p className={styles.important}>
                    You must send all paperwork relating to the load promptly to the Company. All invoices must be sent
                    to <strong>{currentCarrier.email}</strong>
                </p>
            ) : null}
            {fax ? (
                <p dangerouslySetInnerHTML={createMarkup()} />
            ) : (
                <p>
                    {titleWithoutFax}. <strong>{titleThanks}</strong>
                </p>
            )}
        </div>
    );
};

export default Requirements;
